import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { ErrorMessage, Field, useField } from "formik";
import React from "react";
import MuiLabel from "./MuiLabel";
import { Box } from '@mui/material';
import TextError from './TextError';



const PhoneInputField = (props) => {
    const { label, name, ...rest } = props;
    const [field, meta, helpers] = useField(props.name);

    const handleChange = (phone, country) =>{
        const reducedPhone = phone.replace(country.dialCode,'',);
        const contact = "+"+country.dialCode+"-"+reducedPhone;
        helpers.setValue('');         
        helpers.setValue(contact);         
    }


    return (
        <Field name={name} {...rest}>
            {({ field }) => {
                return (
                    <React.Fragment>
                        <div>
                            <MuiLabel {...props} />
                            <PhoneInput
                                className="w-100"
                                {...props}
                                {...field}
                                name={name}
                                international
                                autocompleteSearch={true}
                                // countryCodeEditable={false}
                                countryCallingCodeEditable={false}
                                value={field.value}
                                defaultCountry="NO"
                                onChange={(phone, country) => {handleChange(phone,country)}}
                               
                                
                            />
                            <Box className='error-box'>
                                <ErrorMessage name={name} component={TextError} />
                            </Box>
                        </div>
                    </React.Fragment>
                );
            }}

        </Field>
    );
};

export default PhoneInputField;